<nav>
  <span *ngFor="let crumb of crumbs$ | async">
    <a [routerLink]="crumb.link" [innerHTML]="crumb.label"></a>
  </span>
</nav>
<span>
  {{ title$ | async }}
</span>
